import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox"]

  connect() {
    this.checkboxTargets.forEach(checkbox => {
      this.toggleDependentFields(checkbox)
    })
    this.checkInitialMutualExclusivity();
  }

  checkInitialMutualExclusivity() {
    const milestonesCheckbox = this.element.querySelector('input[name="job_rule_template[milestones_auto_invoice]"][type="checkbox"]')
    const invoicesCheckbox = this.element.querySelector('input[name="job_rule_template[invoices_cis]"][type="checkbox"]')
    if (milestonesCheckbox?.checked && invoicesCheckbox?.checked) {
      invoicesCheckbox.checked = false
      this.toggleDependentFields(invoicesCheckbox)
    }
  }

  checkboxChanged(event) {
    const checkbox = event.target
    this.handleMutualExclusivity(checkbox)
    this.toggleDependentFields(checkbox)
  }

  handleMutualExclusivity(changedCheckbox) {
    const checkboxName = this.getCheckboxFieldName(changedCheckbox)
    
    if (checkboxName === 'milestones_auto_invoice' && changedCheckbox.checked) {
      const invoicesCisCheckbox = this.element.querySelector('input[name="job_rule_template[invoices_cis]"][type="checkbox"]')
      if (invoicesCisCheckbox && invoicesCisCheckbox.checked) {
        invoicesCisCheckbox.checked = false
        this.toggleDependentFields(invoicesCisCheckbox)
      }
    } else if (checkboxName === 'invoices_cis' && changedCheckbox.checked) {
      const milestonesAutoInvoiceCheckbox = this.element.querySelector('input[name="job_rule_template[milestones_auto_invoice]"][type="checkbox"]')
      if (milestonesAutoInvoiceCheckbox && milestonesAutoInvoiceCheckbox.checked) {
        milestonesAutoInvoiceCheckbox.checked = false
        this.toggleDependentFields(milestonesAutoInvoiceCheckbox)
      }
    }
  }

  toggleDependentFields(checkbox) {
    const checkboxName = this.getCheckboxFieldName(checkbox)
    
    if (checkboxName) {
      const dependentDiv = this.element.querySelector(`.${checkboxName}`)
      
      if (dependentDiv) {
        if (checkbox.checked) {
          dependentDiv.style.display = "block"
          this.enableSubgroupCheckboxes(dependentDiv)
        } else {
          dependentDiv.style.display = "none"
          this.disableAndUncheckSubgroupCheckboxes(dependentDiv)
          
          if (checkboxName === 'use_accreditations') {
            this.clearAccreditations(dependentDiv)
          }
        }
      }
    }
  }

  enableSubgroupCheckboxes(container) {
    const checkboxes = container.querySelectorAll('input[type="checkbox"]')
    checkboxes.forEach(checkbox => {
      checkbox.disabled = false
    })
  }

  disableAndUncheckSubgroupCheckboxes(container) {
    const checkboxes = container.querySelectorAll('input[type="checkbox"]')
    checkboxes.forEach(checkbox => {
      checkbox.disabled = true
      checkbox.checked = false
    })
  }

  clearAccreditations(container) {
    const accreditationCheckboxes = container.querySelectorAll('input[name*="accreditation_ids"]')
    accreditationCheckboxes.forEach(checkbox => {
      checkbox.checked = false
      checkbox.disabled = true
    })
    
    this.addHiddenClearInput('job_rule_template[accreditation_ids][]', '')
  }

  addHiddenClearInput(name, value) {
    const existingInput = this.element.querySelector(`input[name="${name}"][data-clear-input="true"]`)
    if (existingInput) {
      existingInput.remove()
    }
    
    const hiddenInput = document.createElement('input')
    hiddenInput.type = 'hidden'
    hiddenInput.name = name
    hiddenInput.value = value
    hiddenInput.setAttribute('data-clear-input', 'true')
    this.element.appendChild(hiddenInput)
  }

  getCheckboxFieldName(checkbox) {
    const match = checkbox.name.match(/\[([^\]]+)\]/)
    return match ? match[1] : null
  }
}
